export { getBestChannelForConversation, isConversation, type IConversationMatchWithChannel } from './types';